if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    

    $('[data-fancybox="fancybox-form"]').fancybox({
        toolbar: false
    });
    $('[data-fancybox="fancybox"]').fancybox({
        protect: true,
        loop: false,
        margin: [40, 0],
        gutter: 12,
        keyboard: true, 
        arrows: true,
        infobar: false,
        toolbar: true,
        buttons: [
            // "slideShow",
            // 'fullScreen',
            // 'thumbs',
            // 'share',
            // "download",
            // 'zoom',
            "close"
        ],
        baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-stage">{{arrows}}</div>' +
            '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
            '</div>' +
            '</div>',

        btnTpl: {
            close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"></button>',

            // Arrows
            arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"></button>',

            arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"></button>'
        },
        image: {
            preload: "auto"
        },

        afterLoad: function(instance, current) {
            var pixelRatio = window.devicePixelRatio || 1;

            if ( pixelRatio > 1.5 ) {
                current.width  = current.width  / pixelRatio;
                current.height = current.height / pixelRatio;
            }
          }
    });
    
    $('.tab-menu a').click(function (e) {
        e.preventDefault();
        var tab = $(this).attr('href');
        $(tab).siblings('.tab-content').removeClass('active');
        $('.tab-menu a').removeClass('active');
        $(this).addClass('active');
        $(tab).addClass('active');
    })
    $('.tab-btn').click(function (e) {
        e.preventDefault();
        var tab = $(this).attr('href');
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $(tab).removeClass('active');
        }else{
            $(tab).siblings('.tab-content').removeClass('active');
            $('.tab-btn').removeClass('active');
            $(this).addClass('active');
            $(tab).addClass('active');
        }
        
    })
    $('.terms-btn').click(function (e) {
        e.preventDefault();
        $(this).next().slideToggle();
    });

    $('.sym-slides').slick();

    $('.mobile-slides').slick({
        fade: false,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 700,
        accessibility: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $('.responsive-slides').slick({
        arrows: false,
        dots: true,
        fade: false,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 700,
        accessibility: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                }
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                }
            }
        ]
    });
   //Capture Checkbox  Service needed
    let checkbox552 = document.querySelectorAll('.field_552_10')[0];
    let groupCheck552 = checkbox552.parentElement.parentElement.parentElement;
    groupCheck552.addEventListener('click', showChecks);
    function showChecks(e){
        console.log("test")
        if(e.target.classList.contains('js-openOptions')){
            let actionCheck = e.target.nextElementSibling;
            actionCheck.style.display ="none";
            e.target.classList.remove('js-openOptions')
            console.log("test")
        }
        else{
            let actionCheck = e.target.nextElementSibling;
            actionCheck.style.display =" block";
            e.target.classList.add('js-openOptions')
        }
    }

   //Capture Checkbox  Service needed
    let checkbox546 = document.querySelectorAll('#id_10_0_546')[0];
    let groupCheck546 = checkbox546.parentElement.parentElement.parentElement;
    groupCheck546.addEventListener('click', showChecks);
    function showChecks(e){
        console.log("test")
        if(e.target.classList.contains('js-openOptions')){
            let actionCheck = e.target.nextElementSibling;
            actionCheck.style.display ="none";
            e.target.classList.remove('js-openOptions')
            console.log("test")
        }
        else{
            let actionCheck = e.target.nextElementSibling;
            actionCheck.style.display =" block";
            e.target.classList.add('js-openOptions')
        }
    }

   

})();